import React from "react";
import "./css/blackWhileModal.css";
import PropTypes from "prop-types";

const BlackWhileModal = ({ blackWhite = [] }) => {
  return (
    <div
      className="modal fade"
      id="fullscreenBlackWhileModal"
      tabIndex="-1"
      aria-labelledby="fullscreenModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-fullscreen">
        <div className="modal-content">
          <div className="modal-header border-0">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>

          <div className="modal-body">
            <div className="container">
              <div className="row g-4 justify-content-center">
                {blackWhite.map((item) => (
                  <div
                    key={item.id}
                    className="col-12 col-md-6 col-lg-5 justify-content-center"
                  >
                    <div className="card border-0 shadow-sm rounded-4 overflow-hidden w-100 h-auto">
                      <img
                        src={item.img}
                        alt={item.title}
                        className="size-image-blackwhite-modal-hv"
                        onContextMenu={(e) => e.preventDefault()}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

BlackWhileModal.propTypes = {
  blackWhite: PropTypes.array,
};

export default BlackWhileModal;
